import Vue from 'vue'
import VueRouter from 'vue-router'

// Auth
import { auth } from '../firebase'

// Views
import Login from '../views/LoginViews/Login.vue'
import Register from '../views/LoginViews/Register.vue'
import Reset from '../views/LoginViews/Reset.vue'
import FourOFour from '../views/UtilityViews/FourOFour.vue'
import Home from '../views/Home.vue'
import Profile from '../views/Profile.vue'
// Disabled import Contact from '../views/Contact.vue'

// Components
import FormOne from '../components/FormOne.vue'
import FormTwo from '../components/FormTwo.vue'
import Inactive from '../components/NotificationComponents/InactiveNotification.vue'
import LoggedOut from '../components/NotificationComponents/LoggedOutNotification.vue'
import Overview from '../components/WelcomePageComponents/Overview.vue'
import Orders from '../components/WelcomePageComponents/Orders.vue'
import DeliveredMaterial from '../components/WelcomePageComponents/DeliveredMaterial.vue'
import PrimaryProfileInfo from '../components/ProfilePageComponents/PrimaryProfileInfo.vue'

// Background
import AuthBg from "@/assets/referencekit-background.png";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { bgImage: AuthBg },
    children: [
      {
        path: 'inactive',
        component: Inactive,
        meta: { bgImage: AuthBg }
      },
      {
        path: 'logged-out',
        component: LoggedOut,
        meta: { bgImage: AuthBg }
      }
    ]
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { transitionName: 'slide', bgImage: AuthBg }
  },
  {
    path: '/reset',
    name: 'Reset',
    component: Reset,
    meta: { transitionName: 'slide', bgImage: AuthBg }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: "/overview",
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'orders',
        name: 'Orders',
        component: Orders,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'delivered-material',
        name: 'DeliveredMaterial',
        component: DeliveredMaterial,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    redirect: "profile/primary-info",
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "primary-info",
        name: "PrimaryProfileInfo",
        component: PrimaryProfileInfo,
        meta: {
          requiresAuth: true
        }
      },
      // {
      //   path: "secondary-info",
      //   name: "SecondaryProfileInfo",
      //   component: SecondaryProfileInfo,
      //   meta: {
      //     requiresAuth: true
      //   }
      // }
    ]

  },
  {
    path: '/commissioning',
    name: 'Commissioning',
    redirect: "Commissioning/firstPart",
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'firstPart',
        component: FormOne,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'secondPart',
        component: FormTwo,
        meta: {
          requiresAuth: true
        }
      }
    ],
    // route level code-splitting
    // this generates a separate chunk (commissioning.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "commissioning" */ '../views/Commissioning.vue')
    },
  },
  // DISABLED {
  //   path: '/contact',
  //   name: 'Contact',
  //   component: Contact,
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  {
    path: '*',
    component: FourOFour
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)

  if (!requiresAuth && auth.currentUser) {
    next ('/overview');
  }
  
  if (requiresAuth && !auth.currentUser) {
    next('/login')
  } else {
    next()
  }
});

router.afterEach(to => {
  if (to.meta && to.meta.bgImage) {
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundPosition = "center";
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundImage = `url(${to.meta.bgImage})`;
  } else {
    document.body.style.backgroundRepeat = "";
    document.body.style.backgroundPosition = "";
    document.body.style.backgroundImage = "";
  }
});

export default router
